/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Ambient_TemperatureInputs */



/**
* | output |
* | --- |
* | "Amb. temp." |
*
* @param {Air_Handler_Unit_Ambient_TemperatureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_ambient_temperature = /** @type {((inputs?: Air_Handler_Unit_Ambient_TemperatureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Ambient_TemperatureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Amb. temp.")
	return /** @type {LocalizedString} */ ("T° amb.")
});